import { render, staticRenderFns } from "./Quests.vue?vue&type=template&id=3bf4947e&scoped=true"
import script from "./Quests.vue?vue&type=script&lang=js"
export * from "./Quests.vue?vue&type=script&lang=js"
import style0 from "./Quests.vue?vue&type=style&index=0&id=3bf4947e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf4947e",
  null
  
)

export default component.exports